import React, { Component } from 'react'
import './index.css'
import IconClose from "../IconClose";
import { LUCKET_DETAILS_BACKGROUND_COLOR, STEP_OPTION, stepOptions } from '../../constants';
import { useDispatch, useSelector } from "react-redux";
import { setStepMenuOpen, setTimeFrameMenuOpen } from '../../slice/buckets';
class LucketStepIcon extends Component {

    state = {
        edit: false
    }


    edit = () => {
        if (this.props.stepMenuOpenProp === false) {
            this.props.setStepMenuOpenProp(true);
            this.props.setTimeFrameMenuOpenProp(false);
        } else {
            this.props.setStepMenuOpenProp(false);
            this.props.setTimeFrameMenuOpenProp(false);
        }

    }

    set = (event, v) => {
        event.stopPropagation();
        this.setState({ edit: false })
        this.props.setStep(v);
    }

    render() {

        return (
            <div className="LucketStepIcon"
                style={{ width: this.props.step === STEP_OPTION.Review && "100px", maxWidth: this.props.step === STEP_OPTION.Review && "100px", borderColor: LUCKET_DETAILS_BACKGROUND_COLOR }}
                onClick={this.edit}>
                {this.props.step}
                {(this.props.stepMenuOpenProp === true) ?
                    <div className="step-menu-container">
                        <div className="StepCallout" />
                        <div id="menu" className="StepMenu">
                            {stepOptions.filter(
                                o => o !== this.props.step
                            ).map(o =>
                                <div className="LucketStepIconShort"
                                    key={o}
                                    onClick={(e) => this.set(e, o)}>
                                    <span className="step-option-text">{o}</span>
                                </div>
                            )}
                            <div className="step-menu-close">
                                <IconClose edit={this.edit} />
                            </div>
                        </div>
                    </div> : null}

            </div>)
    }

}

export default LucketStepIcon